/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { isRichTextEmpty } from "cms/rich-text/richtext-utils";
import { TimelineItem } from "./timeline-item";

const TimelineComponentDisplay = () => {
    const { component } = useContext(ContentZoneContext);
    const { description, link, section, subtitle, timelines, title } = component || {};
    const { text: link_text, url } = link || {};

    const hasLink = link && link_text && url;
    const hasTimelineItems = timelines && timelines.length > 0;

    return (
        <div className='timeline-component-display'>
            {section && <h4>{section}</h4>}
            {title && <h2>{title}</h2>}
            {subtitle && <h2>{subtitle}</h2>}

            {!isRichTextEmpty(description) && <RichTextPreview richtext={description} />}

            {hasLink &&
                <div className='simplicity-linkbutton'>
                    <a className='btn icon' href={url}>
                        {link_text}
                    </a>
                </div>
            }

            {hasTimelineItems &&
                <div className='timeline-items'>
                    {timelines.map((timeline, index) => {
                        return (
                            <TimelineItem key={`timeline-item-${index}`} timelineItem={timeline} />
                        );
                    })}
                </div>
            }
        </div>
    );
};

TimelineComponentDisplay.displayName = "TimelineComponentDisplay";
export { TimelineComponentDisplay };
